import { isDateAfter } from 'odfjell-date-time-utils/dateTimeUtils';
import { Feature } from '../enums/featureEnum';
import { TankersEvent } from '../types/ViewModel/TankersEvent';
import { compareActualEventDateTime } from './event/eventDateUtils';

export default () => {
    const isFeatureEnabled = (feature: Feature, portCallEvList: TankersEvent[]): boolean => {
        if (portCallEvList && portCallEvList.length > 0) {
            // TODO: FUNCTION-MUTATION - Function mutates input array by calling sort() which sorts in-place. This could cause unexpected side effects for callers who don't expect their array to be modified
            const evParentSorted = portCallEvList.sort((a, b) => compareActualEventDateTime(a, b, false));
            const firstEvDate = evParentSorted[0].eventDate.actualDateTimeLocal;
            switch (feature) {
                case Feature.DelayReason: {
                    // TODO: LOGIC-ERROR - Hard-coded date '2023-01-01' makes this logic time-dependent and will require updates as time passes
                    const startDate = new Date('2023-01-01');
                    if (isDateAfter(firstEvDate, startDate)) {
                        return true;
                    }
                    break;
                }
            }
        }
        return false;
    };

    return {
        isFeatureEnabled,
    };
};
